import { getDisplayValue } from "../../formatting/string-manipulation";
import type { Narrative } from "../../types";
import type { Field } from "../tabs/types";

const storyNarratives = [
  { key: "areaThroughTime", name: "Area through time" },
  { key: "goodForPeople", name: "Good for people" },
  { key: "goodForEarth", name: "Good for earth" },
] as const;

export function buildProjectInformationField(
  narrative?: Narrative,
  index = 0,
): Field {
  return {
    name: "Project Information:",
    type: "text",
    index,
    fullLine: true,
    richText: true,
    collapsible: true,
    value: narrative?.projectInformation,
  };
}

export function buildStoryNarrativeFields(
  narrative?: Narrative,
  startIndex = 0,
): Array<Field> {
  return storyNarratives.map(({ key, name }, narrativeIndex) => ({
    name,
    type: "text",
    index: startIndex + narrativeIndex,
    fullLine: true,
    richText: true,
    collapsible: true,
    value: getDisplayValue(narrative?.[key]),
  }));
}

export function buildNarrativeFields(
  narrative?: Narrative,
  startIndex = 0,
): Array<Field> {
  return [
    buildProjectInformationField(narrative, startIndex),
    ...buildStoryNarrativeFields(narrative, startIndex + 1),
  ];
}
